import React from "react";
import classNames from "classnames/bind";
import { Link } from "react-router-dom";

import { Pill } from "src/components";

// icons
import { WalkIcon } from "src/assets/icons";

// styles
import styles from "./VenueSlider.module.scss";

const cx = classNames.bind(styles);
const testImg =
  "https://www.celebrityradio.biz/wp-content/uploads/2015/10/Review-Disney-Aladdin-Musical.jpg";

const VenueItem = () => {
  return (
    <Link to="#">
      <div className={cx("venue-item")}>
        <div className={cx("image-wrapper")}>
          <img src={testImg} alt="..." />
          <Pill label="3 active events" classname={cx("active-label")} />
        </div>
        <div className={cx("main")}>
          <h3 className={cx("title")}>Casino</h3>
          <div className={cx("icon-wrapper")}>
            <span className={cx("icon")}>
              <WalkIcon />
            </span>
            <span className={cx("label")}>10 mile(s) away</span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default VenueItem;
